import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
const $ = window.$;

export default class AssessmentFinished extends Component {
    constructor(props) {
        super(props);
        this.handleModalEnter = this.handleModalEnter.bind(this);
        this.handleModalVerifyPassword = this.handleModalVerifyPassword.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.interceptClick = this.interceptClick.bind(this);
        this.state = {
            showVerifyPasswordModal: false
        };
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    handleModalEnter() {
        try {
            $(".verify-password").focus();
        } catch (e) {
            //
        }
    }

    handleModalClose() {
        this.setState({ showVerifyPasswordModal: false });
    }

    handleModalVerifyPassword() {
        this.setState({ showVerifyPasswordModal: false });
        const password = $(".verify-password").val();
        if (password.length > 0) {
            this.props.verifyPassword(password, () => this.props.next({}));
        }
    }

    interceptClick(type) {
        if (type === "next") {
            this.setState({ showVerifyPasswordModal: true });
            return true;
        }

        return false;
    }

    render() {
        return (
        <div className="test-page-content-inner test-page-assessment-finished">
            <img src="/images/Logo.png" alt="CPP logo" />
            <h1>Please call in your administrator</h1>
            <h1>Thank you</h1>
            <Modal onEnter={this.handleModalEnter} show={this.state.showVerifyPasswordModal} onHide={this.handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Password Required</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-horizontal">
                        <div className="form-group row">
                            <label className="control-label col-sm-4">Password</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control verify-password" autoComplete="none" maxLength="20" />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.handleModalClose}>No thanks</Button>
                    <Button bsStyle="success" onClick={this.handleModalVerifyPassword}>Yes, I'm sure</Button>
                </Modal.Footer>
            </Modal>
        </div>
        );
    }
}
